(function () {
  const classes = {
    accordion: 'js-custom-accordion',
    accordionHead: 'js-custom-accordion-head',
    accordionBody: 'js-custom-accordion-body',
    active: 'active'
  };
  const accordions = document.querySelectorAll(`.${classes.accordion}`);
  accordions.forEach(accordion => {
    var _accordion$parentElem, _accordion$parentElem2;

    const parentAccordionBody = (_accordion$parentElem = accordion.parentElement) === null || _accordion$parentElem === void 0 ? void 0 : (_accordion$parentElem2 = _accordion$parentElem.closest(`.${classes.accordion}`)) === null || _accordion$parentElem2 === void 0 ? void 0 : _accordion$parentElem2.querySelector(`.${classes.accordionBody}`);
    const head = accordion.querySelector(`.${classes.accordionHead}`);
    const body = accordion.querySelector(`.${classes.accordionBody}`);
    const childAccordions = body.querySelectorAll(`.${classes.accordion}`);
    const scrollHeight = body.scrollHeight;
    head.addEventListener('click', () => {
      const active = accordion.classList.contains(classes.active);

      if (active) {
        accordion.classList.remove(classes.active);
        body.style.height = '0px';

        if (parentAccordionBody) {
          parentAccordionBody.style.height = `${parentAccordionBody.offsetHeight - scrollHeight}px`;
        }

        setTimeout(() => {
          childAccordions === null || childAccordions === void 0 ? void 0 : childAccordions.forEach(child => {
            const childActive = child.classList.contains(classes.active);

            if (childActive) {
              const childHead = child.querySelector(`.${classes.accordionHead}`);
              childHead === null || childHead === void 0 ? void 0 : childHead.click();
            }
          });
        }, 250);
      } else {
        accordion.classList.add(classes.active);
        body.style.height = `${scrollHeight}px`;

        if (parentAccordionBody) {
          parentAccordionBody.style.height = `${parentAccordionBody.offsetHeight + scrollHeight}px`;
        }
      }
    });
  });
})();
